import React from 'react';
import { Reveal } from './Reveal';
const withoutItems = ['😓 Planning every step class from scratch', '🔁 Repeating the same 5 patterns every week', '🌙 Spending your evenings building sequences', '💭 Running out of choreography ideas', '😰 Freezing when a student has knee pain', '📉 No class progression — students lose interest'];
const withItems = ['📖 Open the drill bank', '🎯 Choose today’s sequence', '💪 Teach with real professional confidence', '♾️ 50+ drills — always something new', '📅 Plan your week, month, quarter, and teaching year with a structured system', '🏆 Every client progressing every week'];
function Panel({
  title,
  label,
  items,
  positive
}: {
  title: string;
  label: string;
  items: string[];
  positive?: boolean;
}) {
  return <div className={`p-7 sm:p-10 ${positive ? 'bg-mint' : 'bg-surface'}`} data-id="element-29" data-mp="28um6ln5aumkr">
      <p className={`text-xs font-bold uppercase tracking-[0.16em] ${positive ? 'text-green-dark' : 'text-red-500'}`} data-id="element-30" data-mp="9lp5zaepnxud">
        {label}
      </p>
      <h3 className="mt-4 font-display text-2xl font-bold leading-tight text-ink sm:text-3xl" data-id="element-31" data-mp="1m0h16ooeak6g">{title}</h3>
      <ul className="mt-7 divide-y divide-ink/10" data-id="element-32" data-mp="1h9h0r9g2hjz7">
        {items.map(item => <li key={item} className="py-4 text-sm leading-relaxed text-slate sm:text-base" data-id="element-33" data-mp="1h85xdaqjae8m">
            {item}
          </li>)}
      </ul>
    </div>;
}
export function Comparison() {
  return <section className="w-full bg-surface px-4 py-20 sm:py-24" data-id="element-34" data-mp="1877skq89u2oz">
      <div className="mx-auto max-w-6xl" data-id="element-35" data-mp="24yjtpdg5iz90">
        <Reveal className="mx-auto max-w-3xl text-center" data-id="element-36" data-mp="24x8qbeqmbtif">
          <h2 className="font-display text-4xl font-extrabold tracking-tight text-ink sm:text-5xl" data-id="element-37" data-mp="20zb14bwul7f1">
            The Difference a <span className="text-green-dark" data-id="element-38" data-mp="1vx2494gutl7n">Real System</span> Makes
          </h2>
          <p className="mt-5 text-slate" data-id="element-39" data-mp="1qz0mcmv5zrxr">You’re not buying files. You’re buying a complete teaching operating system.</p>
        </Reveal>
        <Reveal delay={0.08} data-id="element-40" data-mp="khdi2fbfcq7w">
          <div className="mt-10 overflow-hidden rounded-2xl border border-ink/10 shadow-elevated md:grid md:grid-cols-2" data-id="element-41" data-mp="fk3u743oomm6">
            <Panel label="❌ WITHOUT" title="Without Step Class Ready™" items={withoutItems} data-id="element-42" data-mp="h33uxzmjaf9z" />
            <Panel positive label="✅ WITH" title="With Step Class Ready™" items={withItems} data-id="element-43" data-mp="lzub0myc9ave" />
          </div>
        </Reveal>
      </div>
    </section>;
}